import http from "plugins/axios";

export default {
  getOrderList({ page, size, coinType,chain,}) {
    return http.get({
      url: `/la/admin/address/balance/getList?page=${page}&size=${size}&coinType=${coinType}&chain=${chain}`,
    });
  },
  getChains(){
    return http.get({
      url:'/la/admin/coin/chain/list'
    })
  },
  exportExcel({  coinType, address,chain,}){
    return http.get({
        url: `/la/admin/address/balance/export?coinType=${coinType}&address=${address}&chain=${chain}`,
        responseType:'blob',
    })
  },
  //链上余额明细
  getDetail({page,size,address,coinType,chain}){
    return http.get({
      url:`/la/admin/address/balance/list?page=${page}&size=${size}&coinType=${coinType}&chain=${chain}&address=${address}`
    })
  },
  getFbsPairs(){
    return http.get({
      url:'admin/symbol/fbsNames' //更改后的路径
      // url:' /la/admin/pair/list'
    })
   },
   getAllCoins() {
    return http.get({
      url: '/la/admin/coin/coin-list'
    });
  },
};
